import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Col, Row, Form, Modal } from 'react-bootstrap'
import { ContactButton, InputWithIcon, NextBackButton } from '../../../ui/CustomElements'
import { Box, InnerHeading, LabelStyled, LazyImage, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowRight, BackArrow, BackArrowActive, NextArrow, SuccessLogo } from '../../../ui/AllImages'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import ImageUpload from '../../uploadFiles/imagesUpload'
import MultipleImageUpload from '../../uploadFiles/MultipleImagesUpload'
import { toast } from 'react-toastify'
import ContactApi from '../../../services/api/contactApi'
import { useForm } from 'react-hook-form'
const StepFive = ({ prevStep, formData, setFormData, setStep }) => {
    const { t, i18n } = useTranslation();
    const [notes, setNotes] = useState(""); 
    const [images, setImages] = useState([]); 
    const [loading, setLoading] = useState(false);
    const { register, reset, handleSubmit, formState: { errors } } = useForm({
        defaultValues: formData, 
    });
    const handlePrevStep = (event) => {
        event.preventDefault();  
        event.stopPropagation(); 
        prevStep();
    };
    const handleNotesChange = (e) => {
        const newNotes = e.target.value;
        setNotes(newNotes);
        setFormData((prev) => ({
            ...prev,
            notes: newNotes, 
        }));
    };
    const handleImagesChange = (newImages) => {
        setImages(newImages);
        setFormData((prev) => ({
            ...prev,
            images: newImages, 
        }));
    };
    useEffect(() => {
        if (formData?.notes) {
            setNotes(formData.notes);
        }
        if (formData?.images) {
            setImages(formData.images);
        }
        reset(formData); 
    }, [formData, reset]);
    const onSubmit = async () => {
        if (!formData.id) {
            return;
        }
        const finalData = new FormData();
        finalData.append("id", formData.id); 
        finalData.append("notes", notes);
        images.forEach((file) => {
            finalData.append("images[]", file);
        });
        try {
            setLoading(true);
            const response = await ContactApi.submitForm({ ...formData, step: 5 }, i18n.language);
            if (response.code === 200) {
                toast.success(t("Formsubmittedsuccessfully"));
                setFormData({});
                setNotes("");
                setImages([]);
                setStep(1);
                if (reset) reset();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Error submitting Step 5:", error);
        } finally {
            setLoading(false);
          }
    };
    return (
        <ContacFormWapper className='contactFormWrapper'>
            <Box>
                <Box className=''>
                    <Box className='d-flex flex-column align-items-start justify-content-start contactHeading'>
                        <InnerHeading className='' lh="1.2" size="20px" color="var(--themeColor)">{t('AdditionalInfo')}</InnerHeading>
                    </Box>
                </Box>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className=''>
                        <Col lg={12} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('Notes')}</LabelStyled>
                            <Box className='textarea-box'>
                                <textarea
                                    cols=""
                                    rows="5"
                                    name="notes"
                                    placeholder={t('WriteAdditionalNotes')}
                                    value={notes} 
                                    onChange={handleNotesChange} 
                                ></textarea>
                            </Box>
                        </Col>
                        <Col lg={12} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('UploadImages')}</LabelStyled>
                            <MultipleImageUpload
                                initialImages={formData.images || []} 
                                onImagesChange={handleImagesChange}
                            />
                        </Col>
                        <Box className='d-flex justify-content-between w-100 mt-5 btnNBWrap'>
                            <NextBackButton type="button" className="" content='end' backIcon={BackArrowActive} label={t('back')} bg="var(--white)" onClick={handlePrevStep} />
                            <Box className="nextTextContainer">
                                <Box className='progressTextContainer'>
                                    <SpanStyled className='txtEng'>
                                        5
                                    </SpanStyled>
                                    <SpanStyled className='ofProgTxt'>
                                        {t("Of")}
                                    </SpanStyled>
                                    <SpanStyled className='txtEng'>
                                        5
                                    </SpanStyled>
                                </Box>
                                <NextBackButton 
                                    type="submit" 
                                    className="" 
                                    nextIcon={NextArrow} 
                                    label={t('Send')} 
                                    isLoading={loading}
                                />
                            </Box>
                        </Box>
                    </Row>
                </Form>
            </Box>
        </ContacFormWapper >
    )
}
const ContacFormWapper = styled.div`
    textarea{
        color: var(--darkGrey) !important;
        border-radius: 6px;
        background: var(--white);
        border: 1px solid var(--border);
        font-size: 14px;
        padding: 15px;
        width: 100%;
        body.rtl &{
            font-family: var(--arRegular);
        }
    }
`
export default StepFive
